import React, { FunctionComponent } from "react";
import { Shimmer } from "sprint-common-web";

import {
    ensureAncillaryContentDetails,
    ensureFullTvSeriesContentDetails,
    ensureMovieContentDetails
} from "../../../../common/types/ContentDetails";
import { ContentSubtype } from "../../../../common/types/ContentSubtype";
import { PageHeader } from "../../../../common/ui/layout/header/PageHeader";
import { useOnPremAssetDetails } from "../common/hooks/useOnPremAssetDetails";
import { OnPremAncillaryDetailsPageHeader } from "./ancillary/OnPremAncillaryDetailsPageHeader";
import { OnPremMovieDetailsPageHeader } from "./movie/OnPremMovieDetailsPageHeader";
import { OnPremTvSeriesDetailsPageHeader } from "./tv-series/OnPremTvSeriesDetailsPageHeader";

export const OnPremAssetDetailsPageHeader: FunctionComponent = () => {
    const { data: assetDetails } = useOnPremAssetDetails();

    const content = assetDetails?.content;

    switch (content?.subtype) {
        case ContentSubtype.Movie:
        case ContentSubtype.TvSingle:
        case ContentSubtype.FeatureDocumentary:
        case ContentSubtype.ShortFilm: {
            ensureMovieContentDetails(content);

            return (
                <OnPremMovieDetailsPageHeader
                    contentType={content.subtype}
                    movie={content.movie}
                    version={content.versionSummary}
                />
            );
        }

        case ContentSubtype.TV: {
            ensureFullTvSeriesContentDetails(content);

            return (
                <OnPremTvSeriesDetailsPageHeader
                    tvSeries={content.tvSeries}
                    season={content.season}
                    episode={content.episode}
                    version={content.versionSummary}
                />
            );
        }

        case ContentSubtype.Advert:
        case ContentSubtype.Promo:
        case ContentSubtype.Safety:
        case ContentSubtype.ClientSpecific:
        case ContentSubtype.IndentWarning: {
            ensureAncillaryContentDetails(content);

            return (
                <OnPremAncillaryDetailsPageHeader
                    contentType={content.subtype}
                    ancillary={content.ancillary}
                    airline={content.airline}
                />
            );
        }

        case undefined:
            return (
                <PageHeader>
                    <Shimmer width="60%" />
                </PageHeader>
            );

        default:
            return <></>;
    }
};
